import { useState } from 'react'
import { AccountRecord, useUpdateAccountMutation } from '../../api/client'
import { AutoAction, getAutoActions } from './autoActions'
import DescriptiveToggle from './DescriptiveToggle'

const AutoMuteSevereAccountToggle = ({ account }: { account: AccountRecord }) => {
    const [updateAccountMutation, { loading }] = useUpdateAccountMutation()

    const [enabled, setEnabled] = useState(account.autoMuteSevereAccount)

    const onToggle = async (isEnabled: boolean) => {
        setEnabled(isEnabled)
        await updateAccountMutation({
            variables: {
                id: Number(account.id),
                autoMuteSevereAccount: !enabled
            }
        })
    }

    const disabled =
        getAutoActions(account.socialMediaServiceDisplayName || '').includes(AutoAction.Mute) ===
        false

    return (
        <DescriptiveToggle
            id={'AutoMuteSevere'}
            disabled={disabled}
            checked={enabled}
            onToggle={onToggle}
            label="Auto-mute profiles producing severe comments"
            subtitle="Automatically mute accounts whose comments that we have classified as 'severe'. (X only)"
            loading={loading}
            tooltip={disabled ? `Not supported by this social network` : ``}
        />
    )
}

export default AutoMuteSevereAccountToggle
